// 2024 Indomitable Might (Barbarian 18): if your total for a Strength check or Strength saving throw is less than your
// Strength score, you can use that score in place of the total. Plain CommonJS, shared by the server's save writers and
// the client's d20 roller.
const { barbarianLevel } = require('./primalChampion');

const INDOMITABLE_MIGHT_LEVEL = 18;
const isStrength = (ability) => ['str', 'strength'].includes(String(ability || '').trim().toLowerCase());

/** The total a level 18+ Barbarian uses for a Strength check or save: the higher of the roll's total and the score. */
function withIndomitableMight(character, ability, total, strengthScore) {
  if (!isStrength(ability) || !Number.isFinite(total) || !Number.isFinite(Number(strengthScore))) return total;
  if (barbarianLevel(character) < INDOMITABLE_MIGHT_LEVEL) return total;
  return Math.max(total, Number(strengthScore));
}

module.exports = { INDOMITABLE_MIGHT_LEVEL, withIndomitableMight };
